export const updateFormStatus = (formId, formStatus) => ({
  setState,
  getState
}) => {
  const selectedFormIndex = getState().formIndex.find(formIndexItem => formIndexItem.id === formId);
  if (selectedFormIndex) {
    const updatedFormIndex = getState().formIndex.map(formIndexItem => {
      if (formIndexItem.id !== selectedFormIndex.id) {
        return formIndexItem;
      }
      return {
        ...formIndexItem,
        status: formStatus
      };
    });
    setState({
      formIndex: updatedFormIndex
    });
  }
};